import HomeIcon from "@mui/icons-material/Home";
import React from "react";

import { FancyLink } from "~/components/parts/FancyLink";

import { posthogEventCoursesHomeClicked } from "~/utils/posthog/courses";

const CoursesHomeLink = ({
  className,
  href = "/view-courses.php",
  posthogTriggerId,
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (posthogTriggerId) {
      posthogEventCoursesHomeClicked({
        triggerId: posthogTriggerId,
      });
    }
    window.location = href;
  };

  return (
    <FancyLink
      {...{ className, href, title: "Go to courses home page" }}
      onClick={handleClick}
    >
      <HomeIcon className="flex-none" sx={{ fontSize: "16px" }} />
      <span>Courses</span>
    </FancyLink>
  );
};

export default CoursesHomeLink;
